module.exports = __webpack_public_path__ + "media/images/product/p_p-0e427a6ed36da799fc5db2da09465d10.png";